/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {login} from '../services'
import {loginUser} from '../../../redux/states/user'
import {AxiosInterceptor} from '../../../interceptors'
import Swal from 'sweetalert2'
import {Link, useNavigate} from 'react-router-dom'
import {
  logoutWithoutSaveToken,
  redirectLogoutMicrosoft,
  getLoadIdWithout,
} from '../services/microsoft.service'

export function LoginGates() {
  const [loading, setLoading] = useState(false)
  const [userParam, setUserParam] = useState('')
  const [token, setToken] = useState('')
  const [messageError, setMessageError] = useState<string>(null)
  const [auth, setAuth] = useState<any>(null)

  const navigate = useNavigate()

  const dispatch = useDispatch()

  useEffect(() => {
    const urlSearchString = window.location.search
    const params = new URLSearchParams(urlSearchString)
    let tokenParam: string = params.get(`t`) || ''
    let user: string = params.get(`q`) || ''
    setToken(tokenParam)
    setUserParam(user)
    setTimeout(() => {
      checkToken(tokenParam)
    }, 100)
  }, [])
  const checkToken = (token_get: string) => {
    if (token_get === '') {
      Swal.fire({
        heightAuto: false,
        text: 'El link ha expirado',
        icon: 'error',
        buttonsStyling: false,
        confirmButtonText: 'Ok',
        customClass: {
          confirmButton: 'btn fw-semobold btn-light-primary',
        },
      }).then(function () {
        window.location.href = '/central/auth'
      })
    }
  }
  useEffect(() => {
    if (token !== '') {
      formik()
    }
  }, [token])

  const formik = async () => {
    setMessageError(null)
    setLoading(true)
    try {
      const {
        data: {data: user, error, message},
      } = await login(userParam, 'GATES', token)
      if (!error) {
        if (!user.cambioContrasena) {
          dispatch(loginUser(user))
        }
        AxiosInterceptor(user)
      } else {
        setAuth(user)
        setMessageError(message)
        setLoading(false)
      }
    } catch (error) {
      console.error(error)
      checkTokenUser()
      setLoading(false)
    }
  }
  const checkTokenUser = (mesaje: string = null) => {
    Swal.fire({
      heightAuto: false,
      text: mesaje ?? 'El usuario no es correcto',
      icon: 'error',
      buttonsStyling: false,
      confirmButtonText: 'Continuar',
      customClass: {
        confirmButton: 'btn fw-semobold btn-light-primary',
      },
    }).then(function () {
      // window.location.href = '/central/auth'
    })
  }
  const redirectLogout = (token: string) => {
    window.location.href = `${redirectLogoutMicrosoft}?q=${token}`
  }
  const handleLogout = async () => {
    try {
      const {metodoLogin, token} = auth
      if (metodoLogin === 'microsoft' && messageError) {
        const {data} = await getLoadIdWithout(token)
        const bulkLoadId = data.BulkLoadId
        const res = await logoutWithoutSaveToken({id: bulkLoadId, token: token})
        if (!res.data.error) {
          localStorage.removeItem('persist:root')
          redirectLogout(bulkLoadId)
        }
      } else {
        navigate('/auth/login')
      }
    } catch (error) {
      console.error(error)
    }
  }
  return (
    <>
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Bienvenido al portal KHIPU</h1>
        {loading && (
          <span className='indicator-progress' style={{display: 'block'}}>
            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            Te estamos redirigiendo al panel...
          </span>
        )}
        <br />
        {messageError ? (
          <div>
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>{messageError}</div>
            </div>

            <button
              type='button'
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-primary'
              onClick={handleLogout}
            >
              Regresar a Login
            </button>
          </div>
        ) : null}
      </div>
    </>
  )
}
